import Api, { make, Response } from 'src/services/api'

import { AddressState, Id } from 'src/types'

type Data = {
  states: AddressState[]
}

type GetAllProps = {
  country: Id
  page?: number
  queryName: string
}

export const PAGE_SIZE = 10

async function getAll({
  country,
  page,
  queryName
}: GetAllProps): Promise<Response<AddressState[]>> {
  return make<Data, AddressState[]>({
    axiosCall: Api.get(
      `states?page_size=${PAGE_SIZE}&page=${
        page || 1
      }&state=${queryName}&country=${country}`
    ),
    transformData: data => data.states
  })
}

export default { getAll }
